<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import logoSVG from '@/assets/images/logo.svg'
import ASidebarMenu from '@/components/ASidebar/ASidebarMenu.vue'

const router = useRouter()
const isCollapsed = ref(false)

const goToDashboardOverview = async () => {
  await router.push({ name: 'dashboard' })
}

const toggleSidebar = () => {
  isCollapsed.value = !isCollapsed.value
}
</script>

<template>
  <div
    class="sidebar-root"
    :class="{ 'is-collapsed': isCollapsed }"
  >
    <button
      type="button"
      class="sidebar-logo-button"
      aria-label="Go to Dashboard overview"
      @click="goToDashboardOverview"
    >
      <img :src="logoSVG" class="sidebar-logo" alt="" />
    </button>
    <div class="sidebar-navigation-surface">
      <button
        type="button"
        class="sidebar-collapse-toggle"
        :aria-label="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
        :title="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
        @click="toggleSidebar"
      >
        <i
          :class="isCollapsed ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'"
          aria-hidden="true"
        />
      </button>
      <ASidebarMenu :collapsed="isCollapsed" />
    </div>
  </div>
</template>

<style scoped>
.sidebar-root {
  display: grid;
  height: 100%;
  min-height: 0;
  flex: 0 0 auto;
  grid-template-rows: var(--c-shell-header-height) minmax(0, 1fr);
  gap: var(--c-shell-gap);
  width: var(--c-shell-sidebar-width);
  transition: width 0.2s ease;
}

.sidebar-root.is-collapsed {
  width: var(--c-shell-sidebar-collapsed-width);
}

.sidebar-logo-button {
  display: flex;
  width: 100%;
  height: var(--c-shell-header-height);
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: var(--c-shell-radius);
  padding: 0 20px;
  background: var(--c-logo-bg);
  cursor: pointer;
}

.sidebar-navigation-surface {
  position: relative;
  min-height: 0;
  overflow: visible;
  border: 0;
  border-radius: var(--c-shell-radius);
  padding: 16px 12px;
  background: var(--c-sidebar-bg);
}

.sidebar-logo {
  display: block;
  width: var(--c-shell-logo-width);
  height: auto;
}

.sidebar-root.is-collapsed .sidebar-logo-button {
  padding-right: 6px;
  padding-left: 6px;
}

.sidebar-root.is-collapsed .sidebar-logo {
  width: var(--c-shell-logo-collapsed-width);
}

.sidebar-root.is-collapsed .sidebar-navigation-surface {
  padding-right: 4px;
  padding-left: 4px;
}

.sidebar-collapse-toggle {
  position: absolute;
  z-index: 2;
  right: 0px;
  bottom: 10%;
  display: grid;
  width: 24px;
  height: 24px;
  place-items: center;
  border: 1px solid var(--c-border-strong);
  border-radius: 999px;
  background: var(--c-panel-bg);
  box-shadow: var(--c-panel-shadow);
  color: var(--c-text-secondary);
  font-size: 10px;
  cursor: pointer;
}

.sidebar-collapse-toggle:hover {
  border-color: var(--p-surface-300);
  background: var(--c-sidebar-hover);
  color: var(--c-sidebar-active-text);
}
</style>
